import './App.css';
import { Routes, Route } from 'react-router-dom'
import { connect } from 'react-redux';
import { useCookies } from 'react-cookie';
import { Login } from './actions/actions.js'
import { cookies_string } from './config.js'
import { validToken } from './services2/request.service.js'
import { useEffect } from 'react';

import MenuBar from './screens2/Header.js';
import PageNotFound from './screens2/PageNotFound.js'
import LoginPage from './screens2/LoginPage.js'
import LoginPageNew from './screens2/LoginPageNew.js'

//admin pages
import AdminHomePage from './screens2/admin/Home.js';
import AdminMenu from './screens2/admin/components/Menu.js';
import AdminMissionsPage from './screens2/admin/Missions.js';
import AdminMissionsDetailsPage from './screens2/admin/MissionsDetails.js';
import AdminResultsPage from './screens2/admin/Results.js';
import AdminResultsDetailsPage from './screens2/admin/ResultsDetails.js';
import AdminResultsSchoolDetailsPage from './screens2/admin/ResultsSchoolDetails.js';
import AdminUsersPage from './screens2/admin/Users.js';
import AdminFaqPage from './screens2/admin/Faq.js';
import AdminSchoolPage from './screens2/admin/School.js';
import AdminRegistrationsPage from './screens2/admin/Registrations.js';
import AdminResultsStudentMissionsPage from './screens2/admin/ResultsStudentMissions.js';
import AdminResultsStudentReportPage from './screens2/admin/ResultsStudentReport.js';
import AdminQuestionnairesPage from './screens2/admin/Questionnaires.js';
import AdminQuestionnaireDetailPage from './screens2/admin/QuestionnaireDetail.js';
import AdminQuestionnaireResultPage from './screens2/admin/QuestionnaireResult.js';
import AdminResultsSchoolStatisticPage from './screens2/admin/ResultsSchoolStatistic.js';
import AdminResultsStudentQuestionnairePage from './screens2/admin/ResultsStudentQuestionnaire.js';
import AdminResultsAllStatisticPage from './screens2/admin/ResultsAllStatistic.js';

//teacher pages
import TeacherHeader from './screens2/teacher/components/Header.js';
import TeacherHomePage from './screens2/teacher/Home.js';
import TeacherMenu from './screens2/teacher/components/Menu.js';
import TeacherResultsPage from './screens2/teacher/Results.js';
import TeacherResultDetailsPage from './screens2/teacher/ResultDetails.js';
import TeacherResultsStudentMissionPage from './screens2/teacher/ResultsStudentMission.js';
import TeacherResultsStudentReportPage from './screens2/teacher/ResultsStudentReport.js';
import TeacherSchoolDetailsPage from './screens2/teacher/SchoolDetails.js';
import TeacherManageStudentsPage from './screens2/teacher/ManageStudents.js';
import TeacherManageMissionsPage from './screens2/teacher/ManageMissions.js';
import TeacherResultStatisticPage from './screens2/teacher/ResultStatistic.js';
import TeacherManageMissionDetailPage from './screens2/teacher/ManageMissionDetail.js';
import TeacherResourcesPage from './screens2/teacher/TeacherResources.js';
import TeacherResearchPractices from './screens2/teacher/ResearchPractices.js';
import TeacherResearchPracticeDetailsPage from './screens2/teacher/ResearchPracticeDetails.js';
import TeacherResearchPracticeTaskPage from './screens2/teacher/ResearchPracticeTask.js';
import TeacherManageStudentResults from './screens2/teacher/ManageStudentResults.js';

//student pages
import StudentHomePage from './screens2/student/Home.js';
import StudentMissionsPage from './screens2/student/Missions.js';
import StudentMissionsDetailsPage from './screens2/student/MissionsDetails.js';
import StudentMenu from './screens2/student/components/Menu.js';
import StudentRecordsPage from './screens2/student/Records.js';
import StudentResultsStudentReportPage from './screens2/student/ResultsStudentReport.js';
import StudentResultsStudentMissionsPage from './screens2/student/ResultsStudentMissions.js';
import StudentHeader from './screens2/student/components/Header.js';

//primary admin pages
import PrimaryAdminRegistrationsPage from './screens2/primary_admin/Registrations.js';
import PrimaryAdminMissionsPage from './screens2/primary_admin/Missions.js';
import PrimaryAdminMissionsDetailsPage from './screens2/primary_admin/MissionsDetails.js';
import PrimaryAdminUsersPage from './screens2/primary_admin/Users.js';
import PrimaryAdminSchoolPage from './screens2/primary_admin/School.js';
import PrimaryAdminQuestionnairesPage from './screens2/primary_admin/Questionnaires.js';
import PrimaryAdminQuestionnaireDetailPage from './screens2/primary_admin/QuestionnaireDetail.js';
import PrimaryAdminQuestionnaireResultPage from './screens2/primary_admin/QuestionnaireResult.js';
import PrimaryAdminResultsPage from './screens2/primary_admin/Results.js';
import PrimaryAdminResultsDetailsPage from './screens2/primary_admin/ResultsDetails.js';
import PrimaryAdminResultsSchoolDetailsPage from './screens2/primary_admin/ResultsSchoolDetails.js';
import PrimaryAdminResultsSchoolStatisticPage from './screens2/primary_admin/ResultsSchoolStatistic.js';
import PrimaryAdminResultsAllStatisticPage from './screens2/primary_admin/ResultsAllStatistic.js';
import PrimaryAdminResultsStudentMissionsPage from './screens2/primary_admin/ResultsStudentMissions.js';
import PrimaryAdminResultsStudentReportPage from './screens2/primary_admin/ResultsStudentReport.js';
import PrimaryAdminResultsStudentQuestionnairePage from './screens2/primary_admin/ResultsStudentQuestionnaire.js';
import PrimaryAdminResultsStudentAbilityPointsPage from './screens2/primary_admin/ResultStudentAbilityPoints.js';

//primary student pages
import PrimaryStudentHomePage from './screens2/primary_student/Home.js';
import PrimaryStudentMissionsPage from './screens2/primary_student/Missions.js';
import PrimaryStudentMissionsDetailsPage from './screens2/primary_student/MissionsDetails.js';
import PrimaryStudentMenu from './screens2/primary_student/components/Menu.js';
import PrimaryStudentRecordsPage from './screens2/primary_student/Records.js';
import PrimaryStudentResultsStudentReportPage from './screens2/primary_student/ResultsStudentReport.js';
import PrimaryStudentResultsStudentMissionsPage from './screens2/primary_student/ResultsStudentMissions.js';
import PrimaryStudentResultsAbilityPointsPage from './screens2/primary_student/ResultsAbilityPoints.js';
import PrimaryStudentReadingStrategiesPage from './screens2/primary_student/ReadingStrategy.js';

//primary teacher pages
import PrimaryTeacherHomePage from './screens2/primary_teacher/Home.js';
import PrimaryTeacherMenu from './screens2/primary_teacher/components/Menu.js';
import PrimaryTeacherResultsPage from './screens2/primary_teacher/Results.js';
import PrimaryTeacherResultDetailsPage from './screens2/primary_teacher/ResultDetails.js';
import PrimaryTeacherResultsStudentMissionPage from './screens2/primary_teacher/ResultsStudentMission.js';
import PrimaryTeacherResultsStudentReportPage from './screens2/primary_teacher/ResultsStudentReport.js';
import PrimaryTeacherSchoolDetailsPage from './screens2/primary_teacher/SchoolDetails.js';
import PrimaryTeacherManageStudentsPage from './screens2/primary_teacher/ManageStudents.js';
import PrimaryTeacherManageMissionsPage from './screens2/primary_teacher/ManageMissions.js';
import PrimaryTeacherResultStatisticPage from './screens2/primary_teacher/ResultStatistic.js';
import PrimaryTeacherResultAbilityPointsPage from './screens2/primary_teacher/ResultAbilityPoints.js';

function App(props) {
  const [cookies, setCookie, removeCookie] = useCookies([`${cookies_string}_cred`, `${cookies_string}_token`]);
  useEffect(() => {
    async function check_token() {
      let login_cred = cookies[`${cookies_string}_cred`];
      let token = cookies[`${cookies_string}_token`];
      if (token && login_cred) {
        let res = await validToken(token)
        if (res?.errno === 0 && login_cred.username && login_cred.usertype) {
          props.dispatch(Login(true, token, login_cred.usertype, login_cred.username))
        }
      } else {
        try {
          removeCookie(`${cookies_string}_token`, '/')
        } catch (e) {
          console.log('cookie err:', e)
        }
      }
    }
    check_token()
  }, [])

  if (!props.token.isLogin)
    return (
      <div className="root" style={{}}>
        <div className='flex-1 w-full flex flex-row' style={{ overflow: 'hidden' }}>
          <Routes>
            <Route path="/login-new" element={<LoginPageNew />} />
            <Route path="/*" element={<LoginPage />} />
          </Routes>
        </div>
      </div>
    );

  if (props.token.usertype === 'admin')
    return (
      <div className="root" style={{}}>
        <MenuBar />
        <div className='flex-1 w-full flex flex-row' style={{ overflow: 'hidden' }}>
          <AdminMenu />
          <Routes>
            <Route path="/" element={<AdminHomePage />} />
            <Route path="/home" element={<AdminHomePage />} />
            <Route path="/missions" element={<AdminMissionsPage />} />
            <Route path="/missions/:id" element={<AdminMissionsDetailsPage />} />
            <Route path="/results" element={<AdminResultsPage />} />
            <Route path="/results/:id" element={<AdminResultsDetailsPage />} />
            <Route path="/results/:id/:schoolId" element={<AdminResultsSchoolDetailsPage />} />
            <Route path="/results/statistic/all/:id" element={<AdminResultsAllStatisticPage />} />
            <Route path="/results/statistic/:id/:schoolId" element={<AdminResultsSchoolStatisticPage />} />
            <Route path='/studentmissions/:id' element={<AdminResultsStudentMissionsPage />} />
            <Route path='/studentreports/:id' element={<AdminResultsStudentReportPage />} />
            <Route path='/studentquestionnaire/:id' element={<AdminResultsStudentQuestionnairePage />} />
            <Route path="/users" element={<AdminUsersPage />} />
            <Route path="/users/school/:id" element={<AdminSchoolPage />} />
            <Route path="/faq" element={<AdminFaqPage />} />
            <Route path="/registrations" element={<AdminRegistrationsPage />} />
            <Route path="/questionnaires" element={<AdminQuestionnairesPage />} />
            <Route path="/questionnaires/:id" element={<AdminQuestionnaireDetailPage />} />
            <Route path="/questionnaires/result/:id" element={<AdminQuestionnaireResultPage />} />
            <Route path="*" element={<PageNotFound />} />
          </Routes>
        </div>
      </div>
    );

  if (props.token.usertype === 'teacher')
    return (
      <div className="w-full flex flex-row h-[100dvh] bg-[#f2f2f2] min-h-[100vh] max-h-[100vh] overflow-auto text-black noto-serif-hk">
        <TeacherMenu />
        <div className='flex-1 flex flex-col h-full' style={{ overflow: 'hidden' }}>
          <TeacherHeader />
          <Routes>
            <Route path="/" element={<TeacherHomePage />} />
            <Route path="/results" element={<TeacherResultsPage />} />
            <Route path="/results/:id" element={<TeacherResultDetailsPage />} />
            <Route path="/results/statistic/:id" element={<TeacherResultStatisticPage />} />
            <Route path="/studentmissions/:id" element={<TeacherResultsStudentMissionPage />} />
            <Route path="/studentreports/:id" element={<TeacherResultsStudentReportPage />} />
            <Route path="/users" element={<TeacherSchoolDetailsPage />} />
            <Route path="/students" element={<TeacherManageStudentResults />} />
            <Route path="/missions" element={<TeacherManageMissionsPage />} />
            <Route path="/missions/:id" element={<TeacherManageMissionDetailPage />} />
            <Route path="/teacher-resources" element={<TeacherResourcesPage />} />
            <Route path="/research-practices" element={<TeacherResearchPractices />} />
            <Route path="/research-practices/preview/:id" element={<TeacherResearchPracticeDetailsPage />} />
            <Route path="/research-practices/:id" element={<TeacherResearchPracticeTaskPage />} />
            <Route path="*" element={<TeacherHomePage />} />
          </Routes>
        </div>
      </div>
    );

  if (props.token.usertype === 'student')
    return (
      <div className="w-full flex flex-row h-[100dvh] bg-[#f2f2f2] min-h-[100vh] max-h-[100vh] overflow-auto text-black noto-serif-hk">
        <StudentMenu />
        <div className='flex-1 flex flex-col h-full' style={{ overflow: 'hidden' }}>
          <StudentHeader />
          <Routes>
            <Route path="/" element={<StudentHomePage />} />
            <Route path="/missions" element={<StudentMissionsPage />} />
            <Route path="/missions/:id" element={<StudentMissionsDetailsPage />} />
            <Route path="/records" element={<StudentRecordsPage />} />
            <Route path="/studentmissions/:id" element={<StudentResultsStudentMissionsPage />} />
            <Route path="/studentreports/:id" element={<StudentResultsStudentReportPage />} />
            <Route path="/research-practices" element={<TeacherResearchPractices />} />
            <Route path="/research-practices/preview/:id" element={<TeacherResearchPracticeDetailsPage />} />
            <Route path="/research-practices/:id" element={<TeacherResearchPracticeTaskPage />} />
            <Route path="*" element={<PageNotFound />} />
          </Routes>
        </div>
      </div>
    );

  if (props.token.usertype === 'p-admin') {
    return (
      <div className="root" style={{}}>
        <MenuBar />
        <div className='flex-1 w-full flex flex-row' style={{ overflow: 'hidden' }}>
          <AdminMenu />
          <Routes>
            <Route path="/" element={<AdminHomePage />} />
            <Route path="/home" element={<AdminHomePage />} />
            <Route path="/registrations" element={<PrimaryAdminRegistrationsPage />} />
            <Route path="/missions" element={<PrimaryAdminMissionsPage />} />
            <Route path="/missions/:id" element={<PrimaryAdminMissionsDetailsPage />} />
            <Route path="/faq" element={<AdminFaqPage />} />
            <Route path="/users" element={<PrimaryAdminUsersPage />} />
            <Route path="/users/school/:id" element={<PrimaryAdminSchoolPage />} />
            <Route path="/questionnaires" element={<PrimaryAdminQuestionnairesPage />} />
            <Route path="/questionnaires/:id" element={<PrimaryAdminQuestionnaireDetailPage />} />
            <Route path="/questionnaires/result/:id" element={<PrimaryAdminQuestionnaireResultPage />} />
            <Route path="/results" element={<PrimaryAdminResultsPage />} />
            <Route path="/results/:id" element={<PrimaryAdminResultsDetailsPage />} />
            <Route path="/results/:id/:schoolId" element={<PrimaryAdminResultsSchoolDetailsPage />} />
            <Route path="/results/statistic/all/:id" element={<PrimaryAdminResultsAllStatisticPage />} />
            <Route path="/results/statistic/:id/:schoolId" element={<PrimaryAdminResultsSchoolStatisticPage />} />
            <Route path='/studentmissions/:id' element={<PrimaryAdminResultsStudentMissionsPage />} />
            <Route path='/studentreports/:id' element={<PrimaryAdminResultsStudentReportPage />} />
            <Route path='/studentquestionnaire/:id' element={<PrimaryAdminResultsStudentQuestionnairePage />} />
            <Route path='/studentabilitypoints/:missionId/:id' element={<PrimaryAdminResultsStudentAbilityPointsPage />} />

            <Route path="*" element={<PageNotFound />} />
          </Routes>
        </div>
      </div>
    );
  }


  if (props.token.usertype === 'p-teacher')
    return (
      <div className="root">
        <MenuBar />
        <div className='flex-1 w-full flex flex-row' style={{ overflow: 'hidden' }}>
          <PrimaryTeacherMenu />
          <Routes>
            <Route path="/" element={<PrimaryTeacherHomePage />} />
            <Route path="/users" element={<PrimaryTeacherSchoolDetailsPage />} />
            <Route path="/students" element={<PrimaryTeacherManageStudentsPage />} />
            <Route path="/results" element={<PrimaryTeacherResultsPage />} />
            <Route path="/results/:id" element={<PrimaryTeacherResultDetailsPage />} />
            <Route path="/studentmissions/:id" element={<PrimaryTeacherResultsStudentMissionPage />} />
            <Route path="/missions" element={<PrimaryTeacherManageMissionsPage />} />
            <Route path="/results/statistic/:id" element={<PrimaryTeacherResultStatisticPage />} />
            <Route path="/studentreports/:id" element={<PrimaryTeacherResultsStudentReportPage />} />
            <Route path='/studentabilitypoints/:missionId/:id' element={<PrimaryTeacherResultAbilityPointsPage />} />
            <Route path="*" element={<PageNotFound />} />
          </Routes>
        </div>
      </div>
    );

  if (props.token.usertype === 'p-student')
    return (
      <div className="root">
        <MenuBar />
        <div className='flex-1 w-full flex flex-row' style={{ overflow: 'hidden' }}>
          <PrimaryStudentMenu />
          <Routes>
            <Route path="/" element={<PrimaryStudentHomePage />} />
            <Route path="/task-4" element={<PrimaryStudentReadingStrategiesPage />} />
            <Route path="/missions" element={<PrimaryStudentMissionsPage />} />
            <Route path="/missions/:id" element={<PrimaryStudentMissionsDetailsPage />} />
            <Route path="/studentmissions/:id" element={<PrimaryStudentResultsStudentMissionsPage />} />
            <Route path="/records" element={<PrimaryStudentRecordsPage />} />
            <Route path="/studentreports/:id" element={<PrimaryStudentResultsStudentReportPage />} />
            <Route path='/studentabilitypoints/:id' element={<PrimaryStudentResultsAbilityPointsPage />} />
            <Route path="*" element={<PageNotFound />} />
          </Routes>
        </div>
      </div>
    );


  return (<PageNotFound />)
}

export default connect((store) => {
  return {
    token: store.tokenReducer,
    control: store.controlReducer,
  }
})(App)